module.exports = __webpack_public_path__ + "img/gongsi_dizhi.46614cc8.svg";